import { render, staticRenderFns } from "./TimeLimitConfig.vue?vue&type=template&id=5ab7db95&scoped=true&"
import script from "./TimeLimitConfig.vue?vue&type=script&lang=js&"
export * from "./TimeLimitConfig.vue?vue&type=script&lang=js&"
import style0 from "./TimeLimitConfig.vue?vue&type=style&index=0&id=5ab7db95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7db95",
  null
  
)

export default component.exports